module.exports = __webpack_public_path__ + "media/stockholm/subway_stairs-6e601c57.jpg";